import React, {useContext} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  if (workExperiences.display) {
    return (
      <div id="experience">
        <div className="experience-container" id="workExperience">
          <div>
            <Fade bottom duration={1000} distance="20px">
              <h1 className="experience-heading">Experiences</h1>
            </Fade>
            <div className="experience-cards-div">
              {workExperiences.experience.map((card, i) => {
                return (
                  <Fade
                    bottom
                    duration={1000}
                    distance="20px"
                    key={i}
                    delay={i * 100}
                  >
                    <ExperienceCard
                      isDark={isDark}
                      cardInfo={{
                        company: card.company,
                        desc: card.desc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        descBullets: card.descBullets
                      }}
                    />
                  </Fade>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
